import { FormLayout } from '@kcftech/design-system';
import { PropertyValueType } from '@kcftech/prometheus-client';
import { WizardContent } from 'components/wizard/WizardContent';
import { AnalyticsParametersInput } from 'pages/Models/AnalyticsModelTab/AnalyticsParametersInput';
import { useForm } from 'react-hook-form';

export type ModelParameterFormData = Readonly<{
    key: string;
    label: string;
    type: PropertyValueType;
    isRequired: boolean;
}>;

export type CreateModelStep2FormData = Readonly<{
    parameters: ModelParameterFormData[];
}>;

export type CreateModelStep2Props = Readonly<{
    data: CreateModelStep2FormData;
    onCancel: () => void;
    onBack: (newData: CreateModelStep2FormData) => void;
    onNext: (newData: CreateModelStep2FormData) => void;
}>;

export function CreateModelStep2({
    data,
    onCancel,
    onBack,
    onNext,
}: CreateModelStep2Props) {
    const form = useForm<CreateModelStep2FormData>({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        defaultValues: data,
        shouldUnregister: false,
    });

    const {
        formState: { isValidating, isSubmitting, isSubmitted, isValid },
        getValues,
        handleSubmit,
    } = form;

    return (
        <WizardContent
            canCancel={!isSubmitting}
            canProceed={!isValidating && !isSubmitting && !(isSubmitted && !isValid)}
            onCancel={onCancel}
            onBack={() => onBack(getValues())}
            onNext={handleSubmit(onNext)}
        >
            <FormLayout>
                <AnalyticsParametersInput form={form} />
            </FormLayout>
        </WizardContent>
    );
}
